import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons'
import Button from '../../../../../Button'
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from 'react-icons/md'
import { useMediaQuery } from 'react-responsive'
import { useTourContext } from '../../../../../../context/TourContext'
import { useAuthContext } from '../../../../../../context'

const Actions = ({
  handleUpdateGrid,
  disabled,
  handleRate,
  solvingTimePercent,
  isCorrect,
  isSubject,
  handleNextGrid,
  handlePrevGrid,
  subjectLength,
  currentGridIndex,
  setRated,
  handleNewSubjectWindow,
  isCreateSubject,
}) => {
  const isSmallDevice = useMediaQuery({
    query: '(max-width:1024px)',
  })
  const { handleNextTourStep } = useTourContext()
  const { userDetails } = useAuthContext()
  return (
    <div className="flex flex-col gap-[10px] p-[5px] md:p-[10px] items-center lg:justify-end lg:max-w-[250px] max-w-none justify-center ">
      {isCorrect && !isSubject ? (
        <div className="hidden text-[11px] sm:text-[15px] md:flex justify-center text-white font-bold text-center">
          {solvingTimePercent === '0%'
            ? 'Felicitări! Ai fost printre cei mai rapizi de pe platformă!'
            : solvingTimePercent === '100%'
              ? 'Ai rezolvat grila destul de încet'
              : `Ai fost in primii ${solvingTimePercent}`}
        </div>
      ) : null}
      <div className="flex w-full items-center justify-center gap-[15px]">
        {isSubject && isSmallDevice ? (
          <Button
            disabled={currentGridIndex === 0}
            className="!p-0 w-[35px] h-[35px] flex !rounded-full text-[18px] bg-btn-primary"
            onClick={handlePrevGrid}
          >
            <MdKeyboardDoubleArrowLeft className="w-[25px] h-[25px] mr-[2px]" />
          </Button>
        ) : null}
        {disabled || isSmallDevice ? null : (
          <FontAwesomeIcon
            icon={faThumbsDown}
            onClick={() => {
              handleRate(-1)
            }}
            disabled={disabled}
            className={`h-[30px] text-over-ternary-background opacity-30 hover:opacity-80 hover:cursor-pointer ${
              disabled &&
              'text-over-ternary-background opacity-100 hover:cursor-default'
            }`}
          />
        )}

        {!isSubject ? (
          <Button
            id="next-grid-button"
            className="pr-5 pl-5 w-[100px] next-grid h-[30px] md:h-[30px] py-2 flex items-center text-over justify-center bg-btn-primary"
            onClick={() => {
              handleUpdateGrid()
              setRated(false)
              if (!userDetails.tutorial) {
                handleNextTourStep()
              }
            }}
          >
            Înainte
          </Button>
        ) : null}

        {disabled || isSmallDevice ? null : (
          <FontAwesomeIcon
            icon={faThumbsUp}
            onClick={() => {
              handleRate(1)
            }}
            disabled={disabled}
            className={`h-[30px] hover:opacity-80 hover:cursor-pointer hover:transition duration-200 text-over-ternary-background opacity-30 ${
              disabled &&
              'text-over-ternary-background opacity-100 hover:cursor-default'
            }`}
          />
        )}
        {isSubject && !isCreateSubject ? (
          <Button
            onClick={() => handleNewSubjectWindow('new')}
            className="lg:hidden flex  h-8 justify-center bg-btn-primary"
          >
            Simulare nouă
          </Button>
        ) : null}
        {isSubject && isSmallDevice ? (
          <Button
            disabled={!(currentGridIndex < subjectLength - 1)}
            className="!p-0 w-[35px] h-[35px] !rounded-full text-[20px] bg-btn-primary"
            onClick={handleNextGrid}
          >
            <MdKeyboardDoubleArrowRight className="w-[25px] h-[25px] ml-[2px]" />
          </Button>
        ) : null}
      </div>
      {isSubject && !isCreateSubject ? (
        <Button
          onClick={() => handleNewSubjectWindow('new')}
          className="hidden xl:hidden lg:flex h-8 bg-btn-primary w-[100px]"
        >
          Simulare nouă
        </Button>
      ) : null}
      {isSubject && !isSmallDevice ? (
        <div className="flex gap-[15px]">
          <Button
            disabled={currentGridIndex === 0}
            className="!p-0 w-[35px] h-[35px] !rounded-full text-[18px] bg-btn-primary"
            onClick={handlePrevGrid}
          >
            <MdKeyboardDoubleArrowLeft className="w-[25px] h-[25px] mr-[2px]" />
          </Button>

          <Button
            disabled={!(currentGridIndex < subjectLength - 1)}
            className="!p-0 w-[35px] h-[35px] !rounded-full text-[18px] bg-btn-primary"
            onClick={handleNextGrid}
          >
            <MdKeyboardDoubleArrowRight className="w-[25px] h-[25px] ml-[2px]" />
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default Actions
